<template>
  <div id="page-container" class="main-content-boxed">
    <main id="main-container">
      <div class="bg-grey">
        <div class="hero-static content content-full bg-grey">
          <div class="py-30 px-5 text-center">
            <a class="link-effect font-w700" href="#">
              <i class="si si-check"></i>
              <span class="font-size-xl text-primary-dark">VM</span><span class="font-size-xl">Control</span>
            </a>
          </div>

          <div class="row justify-content-center px-5">
            <div class="col-lg-4 col-md-6">
              <div class="block">
                <div class="block-header block-header-default">
                  <h3 class="block-title">Inloggen</h3>
                </div>
                <div class="block-content text-center">
                  <img class="img-avatar img-avatar96 img-avatar-thumb" src="/static/img/avatar.jpg" alt="">
                </div>
                <div class="block-content">
                  <alert :alert.sync="alert"></alert>

                  <form @submit.prevent="login">
                    <div class="form-group row">
                      <label class="col-12" for="login-username">Gebruikersnaam</label>
                      <div class="col-12">
                        <input type="text" class="form-control" id="login-username" v-model="username" placeholder="Vul je gebruikersnaam in..." autocomplete="off">
                      </div>
                    </div>
                    <div class="form-group row">
                      <label class="col-12" for="login-password">Wachtwoord</label>
                      <div class="col-12">
                        <input type="password" class="form-control" id="login-password" v-model="password" placeholder="Vul je wachtwoord in..." autocomplete="off">
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-12">
                        <label class="css-control css-control-sm css-control-primary css-switch">
                          <input type="checkbox" v-model="remember" class="css-control-input">
                          <span class="css-control-indicator"></span> Ingelogd blijven
                        </label>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-12">
                        <button type="submit" class="btn btn-block btn-hero btn-noborder btn-primary" :disabled="loading">
                          <i class="fa fa-spinner fa-spin" v-if="loading"></i>
                          <i class="si si-login mr-10" v-else></i>
                          Log in
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  data () {
    return {
      username: '',
      password: '',
      alert: false,
      remember: false,
      loading: false
    }
  },
  methods: {
    login () {
      this.loading = true
      this.$auth.login(this.username, this.password)
        .then(() => {
          this.loading = false
          this.$router.push({ name: 'dashboard' })
        })
        .catch((error) => {
          this.loading = false
          if (error.response && error.response.status === 401) {
            this.alert = { variant: 'danger', message: 'Onjuiste inloggegevens.' }
          } else {
            this.alert = { variant: 'danger', message: 'Er is een fout opgetreden.' }
          }
        })
    }
  },
  mounted () {
    if (this.$route.query.session_expired) {
      this.$swal('Sessie verlopen 😴', 'Log opnieuw in.', 'warning')
      this.$router.replace({ name: 'login' })
    }
  }
}
</script>



// WEBPACK FOOTER //
// LoginPage.vue?56031a95